import gsap from 'gsap';

import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// ScrollTrigger.normalizeScroll({ // モバイル ブラウザのアドレスバーの表示/非表示が防止される
//   allowNestedScroll: true, // これを指定しないと、横スクロール等ができなくなる可能性がある
//   lockAxis: false,
//   // momentum: self => Math.min(3, self.velocityY / 1000), // フリックスクロール時の勢いの継続時間を動的に制御
//   type: "touch,wheel,pointer", // リッスンするアクション
// });

/**
 * create the smooth scroller
 */

let smoother = ScrollSmoother.create({
  wrapper: '#smooth-wrapper',
  content: '#smooth-content',
  effects: true,
  smooth: 1.25
  // speed: 0.8, // これを入れるとハッシュリンクのスクロール時にずれる(原因不明)
});

gsap.config({
  nullTargetWarn: false // コンソールのtarget not foundを表示させない
});

/* css ブレイクポイントの値を取得 */
const root = document.querySelector(':root');
const breakPc = window.getComputedStyle(root).getPropertyValue('--break-pc');
const breakTab = window.getComputedStyle(root).getPropertyValue('--break-tab');
const breakMaxTab = window.getComputedStyle(root).getPropertyValue('--break-maxtab');
const breakMaxSp = window.getComputedStyle(root).getPropertyValue('--break-maxsp');

/* タッチディバイスかどうかを判定する (if文の条件などに使用できる) */
const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

window.onload = function () {
  /**
   * loading 解除
   */

  // 1
  gsap.set('#page', {
    opacity: 0
  });

  gsap.set('#loading', {
    opacity: 1
  });

  const tl_loading = gsap.timeline();

  tl_loading.to('#loading', {
    opacity: 0,
    duration: 0.2,
    onComplete: () => {
      afterLoadingAnim();
    }
  });
  tl_loading.to('#page', {
    opacity: 1,
    duration: 0.2,
    ease: 'power2.out'
  });

  function afterLoadingAnim() {
    /**
     * フルスクリーンナビゲーションのアニメーション
     */

    gsap.set('.fullnav-container', {
      x: 20
    });

    let tl_fn = gsap.timeline();

    tl_fn.to('.fullnav', {
      opacity: 1,
      x: 0,
      scale: 1,
      duration: 0.3,
      pointerEvents: 'auto'
    });
    tl_fn.to('.global-nav .menu-sub-menu-container, .global-nav .menu-sns-menu-container', {
      opacity: 0,
      duration: 0.3
    });
    tl_fn.to('.fullnav-container', {
      x: 0,
      opacity: 1,
      duration: 0.3,
      delay: 0.1
    });

    tl_fn.pause(); // イベントリスナーで発動させるために一時停止。とりあえず表示を確認したい場合はコメントアウトする

    let navToggle = document.getElementById('navToggle');
    let toAccesses = document.querySelectorAll('.fullnav a[href="#access"]');

    const toggleShow = (e) => {
      e.preventDefault();
      e.stopPropagation(); // イベントの伝播を停止

      navToggle.classList.toggle('show');

      const fullnav = document.querySelector('.fullnav');
      fullnav.classList.toggle('show');

      if (navToggle.classList.contains('show')) {
        tl_fn.play();
        smoother.paused(true);
      } else {
        tl_fn.reverse();
        smoother.paused(false);
      }
    };

    if (isTouchDevice) {
      navToggle.addEventListener('touchstart', toggleShow);
      toAccesses.forEach((item) => {
        item.addEventListener('touchstart', toggleShow);
      });
    } else {
      navToggle.addEventListener('click', toggleShow);
      toAccesses.forEach((item) => {
        item.addEventListener('click', toggleShow);
      });
    }

    /**
     * アンカーリンクの生成
     */

    const sections = document.querySelectorAll('section.anchor-section');
    const ul = document.querySelector('ul.anchor-nav-list');

    // ul.anchor-nav-listが存在すれば、
    if (ul) {
      // セクション要素からアンカーナブのリストを生成
      sections.forEach((section) => {
        const id = section.getAttribute('id');
        const h2 = section.querySelector('h2').innerHTML;
        const li = document.createElement('li');
        const a = document.createElement('a');

        // 下向きアローの生成
        let arrowRight = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        arrowRight.setAttribute('width', '7');
        arrowRight.setAttribute('height', '5');
        arrowRight.setAttribute('viewbox', '0 0 7 5');
        arrowRight.setAttribute('fill', 'noe');

        let path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill-rule', 'evenodd');
        path.setAttribute('clip-rule', 'evenodd');
        path.setAttribute(
          'd',
          'M0.146484 1.35353L0.853591 0.646423L3.50004 3.29287L6.14648 0.646423L6.85359 1.35353L3.50004 4.70708L0.146484 1.35353Z'
        );
        path.setAttribute('fill', '111111');

        arrowRight.appendChild(path);

        a.setAttribute('href', `#${id}`);
        a.setAttribute('class', 'flex');
        a.innerHTML = h2;

        li.appendChild(a);
        a.appendChild(arrowRight);
        ul.appendChild(li);
      });
    } else {
      // 存在しなければ、何もしない
      null;
    }

    /**
     * アンカーリンクのスクロールアニメーション (ヘッダーの高さ分を考慮)
     */

    const headerHeight = document.querySelector('header.site-header').clientHeight;
    const offset = headerHeight + 48;

    // アンカーリンク要素を定義
    let links = ".anchor-nav a, a[href^='#sec'], a[href='#access']";

    function anchorScrollAnim(button) {
      button.addEventListener('click', (e) => {
        let id = e.currentTarget.getAttribute('href');
        smoother.scrollTo(id, true, `top ${offset}px`);
        e.preventDefault();
        e.stopPropagation();
      });
    }

    gsap.utils.toArray(links).forEach(function (button, i) {
      anchorScrollAnim(button);
    });

    /**
     * ハッシュリンクの場合、遷移時に該当の箇所までアニメーションさせる
     */
    let urlHash = window.location.href.split('#')[1];
    let scrollElem = document.querySelector('#' + urlHash);

    if (urlHash && scrollElem) {
      gsap.to(smoother, {
        scrollTop: smoother.offset(scrollElem, `top ${offset}px`),
        duration: 1,
        delay: 2
      });
    }

    const body = document.querySelector('body');


    /**
     * アニメーション
     */

    function titleAnim(
      selector,
      timelineName,
      staggerTime = 0.06,
      startTime = 'titleAnimStart',
      lastAnimStartTime = 'titleAnimStart+=0.5'
    ) {
      const mySplitText = new SplitText(selector, {
        type: 'chars'
      });

      gsap.set(
        mySplitText.chars,
        {
          opacity: 0,
          scale: 1.4,
          x: 40,
          //color: "rgba(17, 17, 17, 0)",
          color: 'rgba(1, 148, 215, 0)',
          textShadow: '0px 0px 30px #FFF'
        },
        startTime
      );

      timelineName
        .to(
          mySplitText.chars,
          {
            opacity: 1,
            scale: 1,
            x: 0,
            color: 'rgba(17, 17, 17, 1)',
            textShadow: '0px 0px 20px #0194D7',
            duration: 1,
            ease: 'power2.in',
            stagger: staggerTime
          },
          startTime
        )
        .to(
          mySplitText.chars,
          {
            textShadow: '0px 0px 0px #0194D7',
            duration: 0.5,
            ease: 'power2.Out',
            stagger: staggerTime
          },
          lastAnimStartTime
        );
    }

    if (body.classList.contains('home')) {
      /* MVからサーチリンク */
      gsap.set('top-mv-parallax', {
        y: 10,
        opacity: 0
      });

      let tl = gsap.timeline();

      tl.to('.top-mv-parallax', {
        y: -10,
        opacity: 1,
        duration: 0.5,
        ease: 'Power2.out',
        scrollTrigger: {
          trigger: '.top-mv-parallax',
          start: 'top bottom',
          end: 'bottom top',
          scrub: 3.0
          //markers: true
        }
      });
      tl.from(
        '#swiperTopBanner .swiper-slide',
        {
          opacity: 0,
          y: 40,
          scale: 1,
          ease: 'Power2.out',
          stagger: {
            each: 0.1,
            from: 'start'
          }
        },
        '<0.5'
      );
      tl.from(
        '#swiperTopBanner [class*=swiper-button-]',
        {
          opacity: 0,
          y: 20,
          ease: 'Power2.out',
          stagger: {
            each: 0.1,
            from: 'start'
          }
        },
        '<0.5'
      );
      tl.from(
        '#topBookSearch',
        {
          opacity: 0,
          y: 10,
          ease: 'Power2.out',
          stagger: {
            each: 0.1,
            from: 'start'
          }
        },
        '<0.2'
      );
      tl.from(
        '.search-link',
        {
          opacity: 0,
          y: 10,
          ease: 'Power2.out',
          stagger: {
            each: 0.1,
            from: 'start'
          }
        },
        '<0.2'
      );
      tl.from(
        '#topMvCalendar',
        {
          yPercent: -100,
          duration: 0.5,
          ease: 'power2.out'
        },
        '<1.0'
      );

      /* NEWS */
      let tl2 = gsap.timeline({
        scrollTrigger: {
          trigger: '#topInfo',
          // markers: true,
          start: 'top 95%',
          end: 'bottom 5%',
          // events: onEnter onLeave OnEnterBack onLeaveBack
          toggleActions: 'play none play none'
          // options: play, pause, resume, reset, restart, complete, reverse, none
        }
      });

      titleAnim('#topInfo .title > .title-en', tl2);

      tl2.from(
        '#topInfo .title > .title-ja',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '+=0'
      );
      tl2.from(
        '#topInfo .to-all-page[class*=pc-only]',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          // delay: 0.5,
          ease: 'power2.out'
        },
        '<0.2'
      );
      tl2.from(
        "#topInfo [class*='tab-menu-item_']",
        {
          y: 10,
          opacity: 0,
          // stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );
      tl2.from(
        '#topInfo .post-list',
        {
          y: 10,
          opacity: 0,
          // stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );
      tl2.from(
        '#topInfo .to-all-page.maxtab-only',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          // delay: 0.5,
          ease: 'power2.out'
        },
        '<0.2'
      );

      /* コンテンツリンク */
      gsap.from('#topContentsLink figure', {
        y: 40,
        opacity: 0,
        stagger: 0.1,
        scale: 1.05,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '#topContentsLink',
          start: 'top 95%',
          end: 'bottom 5%',
          toggleActions: 'play none play none'
          // scrub: 1.0,
          //markers: true
        }
      });

      /* EVENT */

      let tl3 = gsap.timeline({
        scrollTrigger: {
          trigger: '#topEvent',
          // markers: true,
          start: 'top 95%',
          end: 'bottom 5%',
          // events: onEnter onLeave OnEnterBack onLeaveBack
          toggleActions: 'play none play none'
          // options: play, pause, resume, reset, restart, complete, reverse, none
        }
      });

      titleAnim('#topEvent .title-en', tl3);

      tl3.from(
        '#topEvent .title-ja',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '+=0'
      );
      tl3.from(
        '#topEvent .to-all-page[class*=pc-only]',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );
      tl3.from(
        '#topEvent .bg',
        {
          // y: 10,
          scaleX: 0,
          opacity: 0,
          ease: 'power2.out',
          transformOrigin: 'left 0'
        },
        '<0.2'
      );
      tl3.from(
        '#topEvent .swiper-slide',
        {
          y: 40,
          opacity: 0,
          scale: 1.05,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '<'
      );
      tl3.from(
        '#topEvent [class*=swiper-button-]',
        {
          opacity: 0,
          y: 20,
          ease: 'Power2.out',
          stagger: {
            each: 0.1,
            from: 'start'
          }
        },
        '<0.2'
      );
      tl3.from(
        '#topEvent .to-all-page.maxtab-only',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out',
          onComplete: () => {
            const setStyle = () => {
              document.querySelector('#swiperTopEvent .swiper-wrapper').style.overflowY = 'visible';
            };
            setTimeout(setStyle, 1000);
          }
        },
        '<0.2'
      );

      /* RECOMMEND */
      let tl4 = gsap.timeline({
        scrollTrigger: {
          trigger: '#topRecommend',
          // markers: true,
          start: 'top 95%',
          end: 'bottom 5%',
          // events: onEnter onLeave OnEnterBack onLeaveBack
          toggleActions: 'play none play none'
          // options: play, pause, resume, reset, restart, complete, reverse, none
        }
      });

      titleAnim('#topRecommend .title-en', tl4, 0.02);

      tl4.from(
        '#topRecommend .title-ja',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '+=0'
      );
      tl4.from(
        '#topRecommend .to-all-page[class*=pc-only]',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );
      tl4.from(
        '#topRecommend .bg',
        {
          // y: 10,
          scaleX: 0,
          opacity: 0,
          duration: 0.5,
          ease: 'power2.out',
          transformOrigin: 'center'
        },
        '<0.2'
      );
      tl4.from(
        '#topRecommend .swiper-slide',
        {
          y: 40,
          opacity: 0,
          scale: 1.05,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '>-0.7'
      );
      tl4.from(
        '#topRecommend [class*=swiper-button-]',
        {
          opacity: 0,
          y: 20,
          ease: 'Power2.out',
          stagger: {
            each: 0.1,
            from: 'start'
          }
        },
        '<1.0'
      );
      tl4.from(
        '#topRecommend .to-all-page.maxtab-only',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );

      /* CALENDAR */
      let tl5 = gsap.timeline({
        scrollTrigger: {
          trigger: '#topCalendar',
          // markers: true,
          start: 'top 95%',
          end: 'bottom 5%',
          // events: onEnter onLeave OnEnterBack onLeaveBack
          toggleActions: 'play none play none'
          // options: play, pause, resume, reset, restart, complete, reverse, none
        }
      });
      titleAnim('#topCalendar .title-en', tl5, 0.02);

      tl5.from(
        '#topCalendar .title-ja',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '+=0'
      );
      tl5.from(
        '#topCalendar .to-all-page[class*=pc-only]',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );
      tl5.from(
        '#topCalendar .bg',
        {
          y: 10,
          opacity: 0,
          ease: 'power2.out',
          transformOrigin: 'center'
        },
        '<0.2'
      );
      tl5.from(
        '#topCalendar .calendar',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );
      tl5.from(
        '#topCalendar .to-all-page.maxtab-only',
        {
          y: 10,
          opacity: 0,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '<0.2'
      );
    }

    /**
     * 下層ページのアニメーション
     */

    if (body.classList.contains('page') || body.classList.contains('single-recommend')) {
      let tl = gsap.timeline();
      tl.from(
        '.title-vertical-line',
        {
          scaleY: 0,
          duration: 0.5,
          delay: 0.2,
          ease: 'power2.out',
          transformOrigin: 'center 0'
        },
        'start'
      );
      tl.from(
        '.group-title .text',
        {
          opacity: 0,
          y: 10,
          duration: 0.5,
          ease: 'power2.out'
        },
        '>-0.2'
      );
      tl.from(
        '.group-title .line',
        {
          scaleX: 0,
          duration: 0.5,
          ease: 'power2.out',
          transformOrigin: 'left left'
        },
        '<0.2'
      );

      tl.to(
        '#heroMv .mask',
        {
          scaleX: 0,
          duration: 1,
          ease: 'power2.out',
          transformOrigin: 'left 0'
        },
        '<'
      );

      titleAnim('h1.page-title', tl, 0.04, '<-0.5', '<+0.5');

      tl.from(
        '.vertical-line',
        {
          scaleY: 0,
          duration: 2,
          ease: 'power2.out',
          transformOrigin: 'center 0'
        },
        'start+=0.7'
      );
      tl.from(
        '#contentsCenter > *',
        {
          y: 10,
          opacity: 0,
          duration: 0.5,
          stagger: 0.2,
          ease: 'power2.out'
        },
        '<1'
      );
      tl.from(
        'aside.sidebar',
        {
          xPercent: 100,
          duration: 0.5,
          ease: 'power2.out'
        },
        '<0.2'
      );

      gsap.utils.toArray('body.under-layer section').forEach((target) => {
        gsap.from(target, {
          duration: 0.5,
          y: 10,
          ease: 'power2.out',
          opacity: 0,
          scrollTrigger: {
            trigger: target,
            // markers: true,
            start: 'top 95%',
            end: 'bottom 5%',

            // events: onEnter onLeave OnEnterBack onLeaveBack
            toggleActions: 'play none play none'
            // options: play, pause, resume, reset, restart, complete, reverse, none
          }
        });
      });
    }

    /**
     * アーカイブ、シングルページのアニメーション
     */

    if (
      body.classList.contains('post-type-archive-news') ||
      body.classList.contains('single-news') ||
      body.classList.contains('post-type-archive-maintenance') ||
      body.classList.contains('single-maintenance') ||
      body.classList.contains('post-type-archive-event') ||
      body.classList.contains('single-event')
    ) {
      let tl = gsap.timeline();
      tl.from(
        '.title-vertical-line',
        {
          scaleY: 0,
          duration: 0.5,
          delay: 0.2,
          ease: 'power2.out',
          transformOrigin: 'center 0'
        },
        'start'
      );
      tl.from(
        '.group-title .text',
        {
          opacity: 0,
          y: 10,
          duration: 0.5,
          ease: 'power2.out'
        },
        '>-0.2'
      );
      tl.from(
        '.group-title .line-long',
        {
          scaleX: 0,
          duration: 0.5,
          ease: 'power2.out',
          transformOrigin: 'left left'
        },
        '<0.2'
      );
      tl.from('.text-big-en', {
        opacity: 0,
        y: 10,
        duration: 0.5,
        ease: 'power2.out'
      });

      tl.from(
        'h1.page-title',
        {
          opacity: 0,
          y: 10,
          duration: 0.5,
          ease: 'power2.out'
        },
        '>-0.2'
      );

      // titleAnim("h1.page-title", tl, 0.02, "<-0.5", "<+0.5")

      tl.from(
        '.vertical-line',
        {
          scaleY: 0,
          duration: 2,
          ease: 'power2.out',
          transformOrigin: 'center 0'
        },
        'start+=0.7'
      );
      tl.from(
        '#contentsCenter > *',
        {
          y: 10,
          opacity: 0,
          duration: 0.5,
          stagger: 0.2,
          ease: 'power2.out'
        },
        '<1'
      );
      tl.from(
        'aside.sidebar',
        {
          xPercent: 100,
          duration: 0.5,
          ease: 'power2.out'
        },
        '<0.2'
      );

      gsap.utils.toArray('body.under-layer section').forEach((target) => {
        gsap.from(target, {
          duration: 0.5,
          y: 10,
          ease: 'power2.out',
          opacity: 0,
          scrollTrigger: {
            trigger: target,
            // markers: true,
            start: 'top 95%',
            end: 'bottom 5%',

            // events: onEnter onLeave OnEnterBack onLeaveBack
            toggleActions: 'play none play none'
            // options: play, pause, resume, reset, restart, complete, reverse, none
          }
        });
      });
    }

    /**
     * テーブルの横スクロール到達後に矢印を非表示にするコード
     */

    const tableArea = document.querySelectorAll('.table-area');
    // const innerHidden = tableArea[0].querySelectorAll(".inner-hidden");
    // const arrow = tableArea[0].querySelectorAll(".table-arrow");

    tableArea.forEach((elem) => {
      const innerHidden = elem.querySelector('.inner-hidden');
      const arrow = elem.querySelector('.table-arrow');

      innerHidden.addEventListener('scroll', (e) => {
        e.preventDefault(); // タッチイベントをキャンセルする

        if (innerHidden.scrollLeft === innerHidden.scrollWidth - innerHidden.clientWidth) {
          arrow.classList.add('none');
        } else {
          arrow.classList.remove('none');
        }
      });
    });

    /**
     * パララックス
     * ※ 対象の要素に、「class="parallax" data-y="-(数字)"」 を付与すること
     */
    gsap.utils.toArray('.parallax').forEach((elem) => {
      const defaultY = -40;

      /* data-y値はパララックスの振り幅 (必ず負の数値) */

      // .parallax要素のdata-y属性を取得。なければデフォルト値を格納
      const y = elem.getAttribute('data-y') || defaultY;

      gsap.set(elem, {
        y: -y // 正の数値に変換し、y値をセット
      });

      gsap.to(elem, {
        y: y,
        scrollTrigger: {
          trigger: elem,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 3.0
          //markers: true
        }
      });
    });

    /**
     * news, maintenance, event アーカイブとシングルページの、タイトル線の長さ調整
     */

    const textEn = document.querySelector('.text-big-en');
    const groupText = document.querySelector('.group-title .text');
    let line = document.querySelector('.group-title .line-long');

    if (window.matchMedia(`(min-width: ${breakTab}px)`).matches) {
      if (textEn && groupText) {
        line.style.width = `calc(100% - ${textEn.clientWidth}px - ${groupText.clientWidth}px - 32px - 32px)`;
      }
    } else if (window.matchMedia(`(max-width: ${breakMaxSp}px)`).matches) {
      if (groupText) {
        if (line) {
          line.style.width = `calc(100% - ${groupText.clientWidth}px)`;
        }
      }
    }

    /**
     * リンクエフェクト
     */

    let items = document.querySelectorAll('header a:not(.btn), .wrapper a:not(.btn), footer a:not(.btn)');
    items.forEach((item) => {
      const tl = gsap
        .timeline({
          paused: true
        })
        .to(item, {
          color: '#0194D7',
          duration: 0.3
        })
        .to(
          item.querySelector('svg path'),
          {
            fill: '#0194D7',
            duration: 0.3
          },
          '<'
        );

      item.addEventListener('mouseenter', () => tl.play());
      item.addEventListener('mouseleave', () => tl.reverse());
    });

    items = document.querySelectorAll('.to-all-page');
    items.forEach((item) => {
      const anim = gsap.to(item, {
        x: 6,
        duration: 0.3,
        paused: true
      });

      item.addEventListener('mouseenter', () => anim.play());
      item.addEventListener('mouseleave', () => anim.reverse());
    });

    items = document.querySelectorAll('ul.anchor-nav-list li');
    items.forEach((item) => {
      const arrow = item.querySelector('svg');
      const anim = gsap.to(arrow, {
        paused: true,
        y: 2,
        duration: 0.3
      });

      item.addEventListener('mouseenter', () => anim.play());
      item.addEventListener('mouseleave', () => anim.reverse());
    });

    /**
     *
     */
    items = document.querySelectorAll('.zoom-image');

    const lbOverlay = document.getElementById('lightboxOverlay');

		function toggleLightboxScroll() {
        lbOverlay.classList.toggle('scroll');
        if (lbOverlay.classList.contains('scroll') == true) {
          smoother.paused(true);
        } else {
          smoother.paused(false);
        }
		}

    items.forEach((item) => {
      item.addEventListener('click', () => {
				toggleLightboxScroll()
      });
    });

    const lbClose = document.querySelector('.lb-close');

    lbClose.addEventListener('click', () => {
			toggleLightboxScroll();
    });

    const lightboxArea = document.getElementById('lightbox');
    lightboxArea.addEventListener('click', () => {
			toggleLightboxScroll();
    });
  } // end afterLoadingAnim()
}; // window.onload

